import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('johnDeereExportModal');

    return {
        FIELDS_LABEL: t('fieldsLabel'),
        NO_FIELDS: t('noFields'),
        NO_ORGANIZATIONS: t('noOrganizations'),
        ORGANIZATIONS_LABEL: t('organizationsLabel'),
        SELECT_ORGANIZATION_PROMPT: t('selectOrganizationPrompt')
    };
};

export default useTranslation;
